import * as React from 'react';
import { IFilterableListSearchResultItem } from '../../global/dtos/filterable-list-results-dto';
import { IAnalytics, GoogleAnalytics } from '../../global/functions/analytics';

export interface IProps {
    result: IFilterableListSearchResultItem;
    itemNumber: number;
    columnOrder: string[];
    columnNames: string[];
    pageTitle: string;
    guestName: string;
    guestEmail: string;
    guestUniqueId: string;
}

export class FilterableListResult extends React.Component<IProps, any> {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="filterable-list-result-item">

                {this.renderRows()}
            </div>
        )
    }

    renderRows = () => {
        const { rowDictionary } = this.props.result;
        const { columnOrder, columnNames } = this.props;

        let keys = Object.getOwnPropertyNames(rowDictionary);
        let lookup = {};
        columnOrder.forEach(function (columnName) {
            lookup[columnName.toLowerCase()] = keys.filter(x => x.toLowerCase() === columnName.toLowerCase())[0];
        })

        var components = [];
        for (let i = 0; i < columnOrder.length; i++) {
            components.push(
                <FilterableListRow
                    rowDictionary={rowDictionary}
                    dictKey={columnOrder[i]}
                    lookup={lookup}
                    key={i}
                    columnNames={columnNames}
                    pageTitle={this.props.pageTitle}
                    guestName={this.props.guestName}
                    guestEmail={this.props.guestEmail}
                    guestUniqueId={this.props.guestUniqueId}
                />
            );
        }

        return components;
    }
}

const FilterableListRow = (props) => {
    let getValue = function (key: string) {
        return props.rowDictionary[props.lookup[key.toLowerCase()]];
    }

    let getColumnName = function (key: string) {
        return props.columnNames.filter(x => x.replace(/[^A-Z0-9]/ig, '').toLowerCase() === key.replace(/[^A-Z0-9]/ig, '').toLowerCase())[0];
    }

    let sendToAnalytics = function () {
        var filterableListPageTitle = props.pageTitle;
        var filterableListUserInfo = props.guestName + " - " + props.guestUniqueId;
        var filterableListPdfUrl = getLinkAddress();

        if (props.guestEmail && props.guestEmail !== "") {
            const analytics = new GoogleAnalytics();
            analytics.pushFilterableListInfo(filterableListPageTitle, filterableListUserInfo, filterableListPdfUrl);
        }
    }

    let getLinkAddress = function () : string {
        let cellValue = getValue(props.dictKey);
        return cellValue.cellLinkAddress;
    }

    let cellValue = getValue(props.dictKey);
    let valueText = cellValue.cellTextValue;
    let valueLink = getLinkAddress();
    let imageLink = cellValue.cellImageAddress;

    return (
        <div className="column filterable-list-result-item-category">
            <span className="filterable-list-result-item-category-title">{getColumnName(props.dictKey)}:</span>

            {imageLink && <img src={imageLink} className="result-image" />}
            {!imageLink && (valueLink ? <a className="result-link" target="_blank" onClick={sendToAnalytics} href={valueLink}>{valueText}</a> : valueText)}
        </div>
    );
}